module.exports = fox._r("images/slides/urban/slide_1_2.jpg", __webpack_public_path__ + "images/slides/urban/slide_1_2.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/urban/slide_1_2.jpg
// module id = 49
// module chunks = 2